import * as Yup from 'yup';

// Base validation for new card (without organization name)
export const baseNewCardSchema = Yup.object({
  paymentMethodType: Yup.string().required('Please select a payment method'),
  billingPeriod: Yup.string().required('Please select a billing period'),
  selectedPlanId: Yup.string().notRequired(),
  billingFirstName: Yup.string().required('First name is required'),
  billingLastName: Yup.string().required('Last name is required'),
  billingEmail: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  billingAddress1: Yup.string().required('Address is required'),
  billingCity: Yup.string().required('City is required'),
  billingState: Yup.string()
    .matches(/^[A-Z]{2}$/, 'State must be 2 letters (e.g., CA)')
    .required('State is required'),
  billingZip: Yup.string().required('ZIP code is required'),
  billingCountry: Yup.string()
    .matches(/^[A-Z]{2}$/, 'Country must be 2 letters (e.g., US)')
    .default('US'),
  billingPhone: Yup.string().notRequired(),
  ccNumber: Yup.string()
    .required('Card number is required')
    .test('cardNumber', 'Invalid card number', (value) => {
      if (!value) return false;
      const digits = value.replace(/\s/g, '');
      return /^\d{13,19}$/.test(digits);
    }),
  ccExp: Yup.string()
    .required('Expiration date is required')
    .matches(/^\d{2}\/\d{2}$/, 'Format must be MM/YY')
    .test('expiration', 'Card has expired', (value) => {
      if (!value) return false;
      // Skip expiration validation in development mode
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      const [month, year] = value.split('/').map(Number);
      const expDate = new Date(2000 + year, month - 1);
      const now = new Date();
      return expDate > now;
    }),
  cvv: Yup.string()
    .required('CVV is required')
    .matches(/^\d{3,4}$/, 'CVV must be 3 or 4 digits'),
});

// Base validation for existing card (without organization name)
export const baseExistingCardSchema = Yup.object({
  billingPeriod: Yup.string().required('Please select a billing period'),
  selectedPlanId: Yup.string().notRequired(),
});

// Organization name schema
const organizationNameSchema = Yup.object({
  organizationName: Yup.string()
    .min(3, 'Organization name must be at least 3 characters')
    .required('Organization name is required'),
});

// Combined schemas for CreateOrganizationModal
export const createOrgNewCardSchema = baseNewCardSchema.concat(organizationNameSchema);
export const createOrgExistingCardSchema = baseExistingCardSchema.concat(organizationNameSchema);

// Re-export for backwards compatibility with existing imports
export const newCardSchema = createOrgNewCardSchema;
export const existingCardSchema = createOrgExistingCardSchema;

// Schemas for ReactivateSubscriptionModal (no organization name needed)
export const reactivateNewCardSchema = baseNewCardSchema;
export const reactivateExistingCardSchema = baseExistingCardSchema;
